/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ChangeLogTypes {
    DefaultPplnsCommission = 'DefaultPplnsCommission',
    DefaultFppsCommission = 'DefaultFppsCommission',
    DefaultPropCommission = 'DefaultPropCommission',
    DefaultPpsCommission = 'DefaultPpsCommission',
    DefaultReferralReward = 'DefaultReferralReward',
    WithdrawalCommission = 'WithdrawalCommission',
    SwapCommission = 'SwapCommission',
    AccountRewardType = 'AccountRewardType',
    PersonalReferralReward = 'PersonalReferralReward',
    PersonalSwapCommission = 'PersonalSwapCommission',
    MinWithdrawalAmount = 'MinWithdrawalAmount',
    DailyWithdrawalThreshold = 'DailyWithdrawalThreshold',
    OneTimeWithdrawalThreshold = 'OneTimeWithdrawalThreshold'
}

